export const EMAILS = [
  { value: "email1", label: "email 1" },
  { value: "email2", label: "email 2" },
  { value: "email3", label: "email 3" },
  { value: "email4", label: "email 4" },
];

export const UNIDADE_TEMPO = [
  // { label: 'Horas', value: 'hours' },
  { label: "Dias", value: "days" },
  { label: "Semanas", value: "weeks" },
  { label: "Meses", value: "months" },
  // { label: "Anos", value: "years" }
];

export const DIAS = [
  { label: "Domingo", value: 0 },
  { label: "Segunda", value: 1 },
  { label: "Terça", value: 2 },
  { label: "Quarta", value: 3 },
  { label: "Quinta", value: 4 },
  { label: "Sexta", value: 5 },
  { label: "Sábado", value: 6 },
];

export const DIAS_MES = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" },
  { value: 12, label: "12" },
  { value: 13, label: "13" },
  { value: 14, label: "14" },
  { value: 15, label: "15" },
  { value: 16, label: "16" },
  { value: 17, label: "17" },
  { value: 18, label: "18" },
  { value: 19, label: "19" },
  { value: 20, label: "20" },
  { value: 21, label: "21" },
  { value: 22, label: "22" },
  { value: 23, label: "23" },
  { value: 24, label: "24" },
  { value: 25, label: "25" },
  { value: 26, label: "26" },
  { value: 27, label: "27" },
  { value: 28, label: "28" },
  { value: 29, label: "29" },
  { value: 30, label: "30" },
  { value: 31, label: "31" },
];

export const TERMOMETRO = [
  { value: null, label: "Todos" },
  { value: 1, label: "Quente" },
  { value: 2, label: "Morno" },
  { value: 3, label: "Congelando" },
  { value: 4, label: "Congelado" },
];

export const SN = [
  { value: null, label: "Todos" },
  { value: 1, label: "Sim" },
  { value: 0, label: "Não" },
];

export const MES = [
  { value: 1, label: "Janeiro" },
  { value: 2, label: "Fevereiro" },
  { value: 3, label: "Março" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Maio" },
  { value: 6, label: "Junho" },
  { value: 7, label: "Julho" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Setembro" },
  { value: 10, label: "Outubro" },
  { value: 11, label: "Novembro" },
  { value: 12, label: "Dezembro" },
];

export const VARIAVEL_CAMPANHA = [
  { name: "ID Pessoa", value: "{{idPessoa}}" },
  { name: "CPF", value: "{{documento}}" },
  { name: "Primeiro Nome", value: "{{primeiroNome}}" },
  { name: "Nome Completo", value: "{{nomeCompleto}}" },
  { name: "Cupom", value: "{{voucher}}" },
  { name: "Cashback", value: "{{cashback}}" },
  { name: "Click Tracker", value: "{{clickTracker}}" },
  { name: "Identificador", value: "{{identificador}}" },
  { name: "Campo 1", value: "{{campo1}}" },
  { name: "Campo 2", value: "{{campo2}}" },
  { name: "Campo 3", value: "{{campo3}}" },
  { name: "Campo 4", value: "{{campo4}}" },
];
